module.exports = __webpack_public_path__ + "img/901477333.aa5ff9c2.jpg";